import React from 'react';
import { config } from 'config';
import {
  createBrowserRouter,
  createHashRouter,
  RouterProvider,
} from 'react-router-dom';
import { appRoutes } from 'app/routing/routes/app';

export const Router = () => {
  const shouldUseHash = config.isElectronBuild || config.isFeatureBuild;
  const createRouter = shouldUseHash ? createHashRouter : createBrowserRouter;
  const routerConfig = shouldUseHash ? {} : { basename: config.basename };

  const router = createRouter(appRoutes, routerConfig);
  return <RouterProvider router={router} />;
};
